import React from 'react';
import classnames from 'classnames';
import OrderHelpers from '../../services/helpers/OrderHelpers';

export default function PrimaryOrderBadge({ order, className, children }) {
  return (
    <div
      className={classnames(
        'bg-primary rounded-lg py-2xs px-xs w-fit',
        {
          '!bg-orange-500': OrderHelpers.isExternalDelivery(order) && !order.is_driver_assigned,
          '!bg-blue-500': order.scheduled_for && !OrderHelpers.isExternalDelivery(order),
        },
        className,
      )}
    >
      <h6 className="text-white">{children}</h6>
    </div>
  );
}
